import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { getScreenName } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getSearchParams } from '../../Parenting/common';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import ButtonOnHover from './ButtonOnHover';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils';
import {
  BlockView,
  BlockViewContainer,
  BundleOfJoySection,
  CardContainer,
  ExploreBtn,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

function BabyCareSection(props) {
  const { gridData } = props;
  const [cardEffect, setCardEffect] = useState({ index: '', effect: '' });
  const router = useRouter();

  const callbackFunction = (index, deeplinkValue, card) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    fireEvent({
      category: 'clicked_card_in_store_home',
      section_name: 'Mylo Baby',
      card_name: card?.text,
      screen_name: getScreenName(),
      deeplink: deeplinkValue,
    });
     const exploreBabyClick = (deeplink = '/category/mylo-baby-7546') => {
    fireEvent({
      category: 'clicked_card_in_store_home',
      section_name: 'Mylo Baby',
      card_name: 'explore_baby_products',
      shape: 'CTA_BUTTON',
      screen_name: getScreenName(),
      deeplink,
      deeplink_value: deeplink,
      query_params: typeof window !== 'undefined' ? window.location.search || 'NA' : 'NA',
      page_url: typeof window !== 'undefined' ? window.location.href.slice(0, 99) : 'NA',
    });
    router.push(`${deeplink}` + getSearchParams(), '', {
      locale: getRouterLocale(router),
    });
  };
    setTimeout(() => {
      router.push(`${deeplinkValue}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  const impressionData = {
    category: 'impression_section_in_store_home',
    section_name: 'Mylo Baby',
  };
  return (
    <ScrollWrapper data={impressionData} threshold={0.5} sectionId="mylo_baby">
      <BlockViewContainer className="myloBaby section2">
        <BlockView>
          {gridData.cards.map((card, index) => {
            const shiftTop = index === 1;

            return (
              <AnchorCoverTag
                url={card?.key}
                cardEffect={
                  index === cardEffect.index ? cardEffect?.effect : ''
                }
                callbackFunction={callbackFunction}
                index={index}
                element={card}
                key={`baby_${index}`}
              >
                <CardContainer
                  className={index % 2 === 0 ? 'card box' : 'card1 box'}
                  index={index}
                  showOverflow={index == 0}
                >
                  {index === 0 ? (
                    <BundleOfJoySection>
                      <img
                        src="https://images.myloapp.in/NestJsUploads/1696316538483-mylo-baby.svg"
                        alt=""
                        loading="lazy"
                      />
                      <p>Joy For Your bundle of Joy</p>
                      <p className="msg">
                        {
                          'Science-backed, gentle and effective personal care and hygiene solutions to raise a happy baby'
                        }
                      </p>
                    </BundleOfJoySection>
                  ) : null}
                  {card.cardImg ? (
                    <Image
                      src={card.cardImg}
                      alt=""
                      quality={90}
                      loading="lazy"
                      fill
                      sizes="33vw"
                    />
                  ) : null}
                  {card?.text ? (
                    <ButtonOnHover
                      text={card?.text}
                      count={card?.totalProducts}
                      shiftTop={shiftTop}
                    />
                  ) : null}
                </CardContainer>
              </AnchorCoverTag>
            );
          })}
          {/* <div></div> */}
        </BlockView>
        <AnchorCoverTag url={'/category/mylo-baby-7546'}
         callbackFunction={()=> exploreBabyClick('/category/mylo-baby-7546')}
>
          <ExploreBtn baby={true}>Explore Baby Products</ExploreBtn>
        </AnchorCoverTag>
        {/* <StackCardSection height="40px" className="stack3" /> */}
      </BlockViewContainer>
    </ScrollWrapper>
  );
}

export default BabyCareSection;
